export const generalMixin = {
  methods: {
    replaceErrorImg(e, size) {
      const elm = e.target;
      if (elm.parentNode) {
        const noImgElm = document.createElement('div');
        noImgElm.className = `img-${size} img-blank-user rounded-circle`;

        elm.parentNode.insertBefore(noImgElm, elm);
        elm.remove();
      }
    },
    logout() {
      if (window.Moengage) window.Moengage.destroy_session();
      if (window.jimo) window.jimo = null;
      if (this.$intercom) this.$intercom.shutdown();
      this.removeLoginData();

      if (this.$isUsingSSO) window.location.href = `${this.$sso.url}sign_out?client_id=${this.$sso.id}`;
      else this.$router.push({ name: 'login' });
    },
    removeLoginData() {
      localStorage.clear();
      this.$store.dispatch('resetCookies');
    },
    makeSlug(string) {
      let slug = '';
      if (string !== undefined) {
        const title = string.toLowerCase();
        const newString = title.trim ? title.trim() : title.replace(/^\s+|\s+$/g, '');
        slug = newString.split(/\s+/).join('-');
      }
      return slug;
    },
  },
};

export const inputNumericalMixin = {
  methods: {
    formatInputCurrencyDecimal(e, closestElm) {
      e.target.value = e.target.value.replace(/(?!^-)[^\d,]/g, '');
      const formatedVal = e.target.value.replace(',', '.'); // convert Indonesian decimal "," to "."

      // assign real value (only number) to hidden input
      const actualInput = closestElm ? e.target.closest(closestElm).nextElementSibling : e.target.nextElementSibling;
      actualInput.value = !Number.isNaN(parseFloat(formatedVal)) ? parseFloat(formatedVal).toFixed(2) : '';
      actualInput.dispatchEvent(new Event('input'));

      if (e.target.value.slice(-1) !== ',' && e.target.value.slice(-2) !== ',0') e.target.value = this.formatCurrency(formatedVal); // format number to currency
    },
    formatInputCurrency(e, closestElm) {
      e.target.value = e.target.value.replace(/(?!^-)[^0-9]/g, '');
      const isMinus = e.target.value.charAt(0) === '-';
      // assign real value (only number) to hidden input
      const actualInput = closestElm ? e.target.closest(closestElm).nextElementSibling : e.target.nextElementSibling;
      actualInput.value = e.target.value;
      actualInput.dispatchEvent(new Event('input'));

      e.target.value = this.formatCurrency(e.target.value, isMinus); // format number to currency
    },
    formatInputNumber(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
      e.target.dispatchEvent(new Event('input'));
    },
    formatCurrency(value, isMinus) {
      const val = parseFloat(value);
      if (!Number.isNaN(val)) return val.toLocaleString('id-ID', { maximumFractionDigits: 2 });
      return isMinus ? '-' : '';
    },
    formatInputGoal($event) {
      // TO DO improvement: replace formatInputGoal to formatInputCurrencyDecimal & remove the measurement_type
      // previously the measurement === 4 (rupiah) was unable to use decimal
      return this.formatInputCurrencyDecimal($event, '.format-currency-wrapper');
    },
  },
};

export const formatDateMixin = {
  methods: {
    formatDateRange(start, end, noreplace) {
      let startDate;
      let endDate;
      if (noreplace) {
        // prevent error replace
        startDate = new Date(start);
        endDate = new Date(end);
      } else {
        // this use for safari
        startDate = new Date(start.replace(/\s/, 'T'));
        endDate = new Date(end.replace(/\s/, 'T'));
      }

      const sameYear = startDate.getFullYear() === endDate.getFullYear();
      const sameMonth = startDate.getMonth() === endDate.getMonth();

      if (sameYear && sameMonth) {
        return `${startDate.getDate()} - ${this.formatDateMonthYear(end)}`;
      }
      if (sameYear) {
        return `${this.formatDateMonth(start)} - ${this.formatDateMonthYear(end)}`;
      }
      return `${this.formatDateMonthYear(start)} - ${this.formatDateMonthYear(end)}`;
    },
    /**
     * Please avoid to use this function. Please refer to /helpers/date.js for its replacement.
     *
     * @deprecated
     * @param  {} value
     * @param  {} noreplace
     */
    formatDateMonth(value, noreplace) {
      let activityDate;
      if (noreplace) {
        activityDate = new Date(value); // prevent error replace
      } else {
        activityDate = new Date(value.replace(/\s/, 'T')); // this use for safari
      }

      return activityDate.toLocaleString('EN-GB', {
        day: 'numeric',
        month: 'short',
      });
    },
    /**
     * Please avoid to use this function. Please refer to /helpers/date.js for its replacement.
     *
     * @deprecated
     * @param  {} value
     * @param  {} noreplace
     */
    formatDateMonthYear(value, noreplace) {
      if (value) {
        let activityDate;
        if (noreplace) {
          activityDate = new Date(value); // prevent error replace
        } else {
          activityDate = new Date(value.replace(/\s/, 'T')); // this use for safari
        }

        return activityDate.toLocaleString('EN-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
      }
      return '';
    },
    /**
     * Please avoid to use this function. Please refer to /helpers/date.js for its replacement.
     *
     * @deprecated
     * @param  {} value
     * @param  {} noreplace
     */
    formatHour(value, noreplace) {
      if (value) {
        let activityDate;
        if (noreplace) {
          activityDate = new Date(value); // prevent error replace
        } else {
          activityDate = new Date(value.replace(/\s/, 'T')); // this use for safari
        }

        return activityDate.toLocaleString('EN-US', {
          hour: '2-digit',
          minute: '2-digit',
        });
      }
      return '';
    },
    /**
     * Please avoid to use this function. Please refer to /helpers/date.js for its replacement.
     *
     * @deprecated
     * @param  {} value
     * @param  {} noreplace
     */
    formatDateApi(value) {
      const toDate = new Date(value);
      const date = String(toDate.getDate()).padStart(2, '0');
      const month = String(toDate.getMonth() + 1).padStart(2, '0');
      const year = toDate.getFullYear();
      return `${year}-${month}-${date}`;
    },
  },
};

export const checkAllMixin = {
  methods: {
    parentCheckAll(event, type, optIsBulk) {
      const elm = event.currentTarget;
      const actionChanges = type === 'unselect' ? false : elm.checked;
      const checkAllWrapper = elm?.closest('.checkallbox-wrapper') || document.querySelector('.checkallbox-wrapper');

      const childCbList = checkAllWrapper.querySelectorAll("input[type='checkbox']:not(.checkallbox-parent)");

      childCbList.forEach(element => {
        element.checked = actionChanges;
        element.dispatchEvent(new Event('change'));
      });

      if (type === 'table-checkall') {
        const isBulk = checkAllWrapper.getAttribute('data-bulk');
        let bulkElm;

        if (isBulk === 'true') {
          isBulk.toLowerCase();
          bulkElm = checkAllWrapper.querySelector('.bulkaction-parent');

          // optIsBulk is to force bulk (check the checked length from model, not only current page)
          if (actionChanges) {
            // show bulk action
            this.toggleBulkTable('show', bulkElm, childCbList.length);
          } else if (!optIsBulk) {
            // hide bulk action
            this.toggleBulkTable('hide', bulkElm);
          }
        }
      }
    },
    childCheckAll(event, type, optCheckedLength) {
      const elm = event.currentTarget;
      const checkAllWrapper = elm.closest('.checkallbox-wrapper');
      const parentCb = checkAllWrapper.querySelector('input.checkallbox-parent');
      const nodeChildCbList = checkAllWrapper.querySelectorAll("input[type='checkbox']:not(.checkallbox-parent)");
      const arrayListChildCb = Array.from(nodeChildCbList);

      const totalChildCb = arrayListChildCb.length;
      const totalChildChecked = arrayListChildCb.filter(x => x.checked).length;
      parentCb.checked = !!(totalChildChecked === totalChildCb && totalChildCb > 0);

      if (type === 'table-checkall') {
        const isBulk = checkAllWrapper.getAttribute('data-bulk');
        let bulkElm;

        if (isBulk === 'true') {
          isBulk.toLowerCase();
          bulkElm = checkAllWrapper.querySelector('.bulkaction-parent');

          // optCheckedLength to get checked length from model, not only current page
          if (totalChildChecked > 0 || optCheckedLength > 0) {
            // show bulk action
            this.toggleBulkTable('show', bulkElm, optCheckedLength || totalChildChecked);
          } else {
            // hide bulk action
            this.toggleBulkTable('hide', bulkElm);
          }
        }
      }
    },
    toggleBulkTable(action, elm, totalCb) {
      const tableWrapper = elm.closest('.checkallbox-wrapper');
      const colspanLength = tableWrapper.querySelectorAll('thead tr th')?.length;
      const bulkWrapper = tableWrapper.querySelector('.bulkaction-content-wrapper');

      if (action === 'show') {
        tableWrapper.classList.add('is-bulk');
        elm.setAttribute('colspan', colspanLength);

        if (bulkWrapper) {
          bulkWrapper.classList.remove('d-none');
          bulkWrapper.classList.add('d-inline-block');
          tableWrapper.querySelector('.bulkaction-content-wrapper .bulkaction-count').innerText = totalCb;
        }
      } else {
        tableWrapper.classList.remove('is-bulk');
        elm.setAttribute('colspan', '1');
        if (bulkWrapper) {
          bulkWrapper.classList.add('d-none');
          bulkWrapper.classList.remove('d-inline-block');
        }
      }
    },
    cancelBulk(event) {
      const cancelBtn = event?.currentTarget;
      const elm = cancelBtn ? cancelBtn.closest('.bulkaction-parent') : document.querySelector('.bulkaction-parent');

      this.resetBulk(elm);
    },
    resetBulk(elm) {
      const tableWrapper = elm?.closest('.checkallbox-wrapper');
      tableWrapper.classList.remove('is-bulk');
      elm.setAttribute('colspan', '1');
      elm.querySelector('.bulkaction-content-wrapper').classList.add('d-none');
      elm.querySelector('.bulkaction-content-wrapper').classList.remove('d-inline-block');
      const nodeListChildChecked = tableWrapper.querySelectorAll("input[type='checkbox']:checked");
      const arrayListChildCb = Array.from(nodeListChildChecked);
      arrayListChildCb.forEach(element => {
        element.checked = false;
      });
    },
  },
};

export const dropdownMixin = {
  methods: {
    openDropdown(event, type) {
      event.stopPropagation();
      event.preventDefault();

      const openDropdown = document.querySelectorAll('.dropdown-menu-content.show');
      if (openDropdown.length) {
        openDropdown.forEach(element => {
          element.classList.remove('show');
        });
      }

      const { target } = event;
      const dropdownContent = target.closest('.dropdown').querySelector('.dropdown-menu');
      if (dropdownContent) dropdownContent.classList.toggle('show');

      if (type === 'down') {
        dropdownContent.style.top = 'auto';
      } else if (type === 'up') {
        dropdownContent.style.top = 'auto';
        dropdownContent.style.bottom = '100%';
      }

      window.onclick = function () {
        const openedDropdown = document.querySelectorAll('.dropdown-menu-content.show');
        if (openedDropdown.length) {
          openedDropdown.forEach(element => {
            element.classList.remove('show');
          });
        }
      };
    },
    searchDropdown(event) {
      const { target } = event;
      const searchKey = target.value;
      const contentWrapper = target.closest('.dropdown-menu-content');
      const optionItem = [...contentWrapper.querySelectorAll('.dropdown-menu-content__item')];
      const resetButton = contentWrapper.querySelector('.dropdown-menu-content__reset');

      if (resetButton) {
        if (searchKey.length) {
          resetButton.classList.add('d-block');
        } else {
          resetButton.classList.remove('d-block');
        }
      }

      optionItem.forEach(elm => {
        if (elm.querySelector('label').textContent.trim().toLowerCase().indexOf(searchKey.toLowerCase()) >= 0) {
          elm.classList.remove('d-none');
          elm.classList.remove('disabled');
        } else {
          elm.classList.add('d-none');
          elm.classList.add('disabled');
        }
      });

      const disabledOption = [...contentWrapper.querySelectorAll('.dropdown-menu-content__item.disabled')];
      if (disabledOption.length === optionItem.length) {
        if (!contentWrapper.querySelector('.option-not-found')) {
          contentWrapper.insertAdjacentHTML('beforeend', '<p class="option-not-found text-center p-3">No matching data found</p>');
        }
      } else {
        const notFoundElm = contentWrapper.querySelector('.option-not-found');
        if (notFoundElm) {
          notFoundElm.remove();
        }
      }
    },
    resetSearchDropdown(ev) {
      const { target } = ev;
      const contentWrapper = target.closest('.dropdown-menu-content');
      const optionItem = [...contentWrapper.querySelectorAll('.dropdown-menu-content__item')];

      const notFoundElm = contentWrapper.querySelector('.option-not-found');
      if (notFoundElm) {
        notFoundElm.remove();
      }

      if (target.classList.contains('dropdown-menu-content__reset')) {
        target.closest('.dropdown-menu-content__search').querySelector('input').value = '';
        target.classList.remove('d-block');
      }

      optionItem.forEach(elm => {
        elm.classList.remove('d-none');
        elm.classList.remove('disabled');
      });
    },
  },
};

export const multidropdownMixin = {
  data() {
    return {
      activeFilter: null,
    };
  },
  methods: {
    filterOptionHover(target) {
      this.activeFilter = target;
    },
    resetFilterOption() {
      this.activeFilter = '';
      const activeDropdowns = document.querySelectorAll('.multidropdown.is-show');

      if (activeDropdowns.length) {
        activeDropdowns.forEach(activeDropdown => {
          const leftMenuActive = activeDropdown.querySelector('.dropdown-leftmenu.is-show');
          if (leftMenuActive) {
            leftMenuActive.classList.remove('is-show');
          }

          const subMenuActive = activeDropdown.querySelector('.dropdown-menu.is-show');
          if (subMenuActive) {
            subMenuActive.classList.remove('is-show');
          }
        });
      }
    },
  },
  watch: {
    activeFilter(val) {
      if (val !== '') {
        const target = this.$refs[val];
        target.closest('.multidropdown').classList.add('is-show');

        // reset active subdropdown
        const currentActive = target.closest('.multidropdown').querySelector('.dropdown-submenu .dropdown-menu.is-show');
        if (currentActive) {
          currentActive.classList.remove('is-show');
        }

        // keep left menu showed
        const leftMenu = target.closest('.multidropdown').querySelector('.dropdown-leftmenu');
        leftMenu.classList.add('is-show');

        // show submenu
        const leftPos = leftMenu.offsetWidth;
        target.style.left = `${leftPos - 12}px`;
        target.querySelector('.dropdown-menu').classList.add('is-show');
      }
    },
  },
};

export const alertMixin = {
  methods: {
    alertToast(text, type, duration) {
      const variant = type === 'danger' ? 'error' : 'success';
      this.$toast({
        variant,
        title: text.toString(),
        duration,
        position: 'top',
      });
    },
    alertToastCustom(text, variant, pageName, linkText = 'here') {
      this.$toast({
        variant,
        title: text.toString(),
        position: 'top',
        render: () => (
          <MpFlex display="inline-flex" gap="1">
            <MpText>{text}</MpText>
            <MpText color="blue.500" textDecoration="underline" cursor="pointer" nativeOnClick={() => this.onOpenNewTab(pageName)}>
              {linkText}
            </MpText>
          </MpFlex>
        ),
      });
    },
    onOpenNewTab(page) {
      const routeData = this.$router.resolve({ name: page });
      window.open(routeData.href, '_blank');
    },
  },
};
